import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { IntegrationsPage } from '../../../../modules/integrations/integrations-page'
import { SettingsShell } from '../../../../modules/settings/settings-shell'
import { PANEL_TYPES } from '../../../../shell/panel-state'

// Integration panel registration - a DYNAMIC import so the connector detail
// panel graph (~60 KB source) stays out of the entry chunk (route files'
// top-level code ships eagerly with the route tree). The record-panel registry
// notifies the host on late registration, so `?panel=integration` deep links
// upgrade to the real panel as soon as this chunk lands.
void import('../../../../modules/integrations/register-panels')

/**
 * The integrations settings surface (PLAN-12). It follows the object-grid pattern:
 * grid state and the right-side integration panel live in the URL.
 */
const integrationsSearchSchema = z.object({
  q: z.string().optional(),
  connector: z.string().optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
})

export const Route = createFileRoute('/_authed/settings/integrations/')({
  validateSearch: integrationsSearchSchema,
  component: IntegrationsRoute,
})

function IntegrationsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()

  return (
    <SettingsShell>
      <IntegrationsPage
        search={search}
        setSearch={(patch) =>
          navigate({
            to: '.',
            search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
            replace: true,
          })
        }
      />
    </SettingsShell>
  )
}
